import { render, staticRenderFns } from "./AdvanceTabPage.vue?vue&type=template&id=5897824c&"
import script from "./AdvanceTabPage.vue?vue&type=script&lang=js&"
export * from "./AdvanceTabPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports